module.exports = __webpack_public_path__ + "static/media/backendlogo.1b93c85d.svg";